import Vue from 'vue';
import Vuex from 'vuex';
import { auth } from './auth';
import { user } from './user';
import { IRootStore } from './types';

Vue.use(Vuex);

export default new Vuex.Store<IRootStore>({
  modules: {
    auth,
    user,
  },
});
